import { ChevronUp } from "lucide-react";
import { useEffect, useState } from "react";

interface BtnGoToTopProps {
  icon?: JSX.Element;
  classNamePosition?: string;
}

export default function BtnGoToTop({ icon = <ChevronUp />, classNamePosition = "bottom-10 right-5" }: BtnGoToTopProps) {
  const [showGoTop, setShowGoTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowGoTop(window.pageYOffset > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`fixed ${classNamePosition} flex items-center justify-center
        w-12 h-12 rounded-full shadow-lg shadow-blue-500/50 transition-all duration-300 z-50 
        bg-gradient-to-r bg-primary text-white hover:scale-110 hover:opacity-90  ${showGoTop ? "opacity-100 scale-100" : "opacity-0 scale-0"}`}
      onClick={() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
    >
      <button className="">{icon}</button>
    </div>
  );
}
